import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: "flex flex-col h-full bg-white border-r border-gray-200",
    style: { "width": "340px" }
};
const _hoisted_2 = {
    class: "flex flex-col flex-shrink-0 gap-3 px-4 pt-5 pb-3 border-b",
    style: { "border-color": "#f3f4f6" }
};
const _hoisted_3 = { class: "text-[20px] font-bold text-[#1A1A1A]" };
const _hoisted_4 = { class: "text-[12px] text-[#6B7280] mt-0.5" };
const _hoisted_5 = { class: "flex items-center gap-1.5" };
const _hoisted_6 = ["onClick"];
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { IconPlus, IconFilter, IconChevronDown } from "@tabler/icons-vue";
import { getLoginUserId } from "@/plugins/shared";
import ConversationList from "./ConversationList.vue";
import ConversationFilters from "./ConversationFilters.vue";
import { conversationService } from "../services/conversation.service";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConversationSidebar',
    props: {
        conversations: {},
        activeConversationId: {},
        isLoading: { type: Boolean },
        services: {},
        itineraries: {}
    },
    emits: ["select", "new-conversation"],
    setup(__props) {
        const props = __props;
        const currentUserId = String(getLoginUserId());
        const { t } = useI18n();
        const tabs = computed(() => [
            { label: t("conversation.sidebar.tabs.all"), value: "all" },
            { label: t("conversation.sidebar.tabs.active"), value: "active" },
            { label: t("conversation.sidebar.tabs.pending"), value: "pending" },
        ]);
        const activeTab = ref("all");
        const filtersOpen = ref(false);
        const activeFilters = ref({});
        const filterContainerRef = ref(null);
        function handleOutsideClick(event) {
            if (filtersOpen.value &&
                filterContainerRef.value &&
                !filterContainerRef.value.contains(event.target)) {
                filtersOpen.value = false;
            }
        }
        onMounted(() => document.addEventListener('mousedown', handleOutsideClick));
        onUnmounted(() => document.removeEventListener('mousedown', handleOutsideClick));
        const tabFiltered = computed(() => {
            if (activeTab.value === "active") {
                return props.conversations.filter((c) => c.status === "ACTIVE");
            }
            if (activeTab.value === "pending") {
                return props.conversations.filter((c) => c.status === "ACTIVE");
            }
            return props.conversations;
        });
        const filteredConversations = computed(() => conversationService.filterConversations(tabFiltered.value, activeFilters.value));
        function handleApplyFilters(filters) {
            activeFilters.value = filters;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("conversation.sidebar.title")), 1),
                        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("conversation.sidebar.description")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                            return (_openBlock(), _createElementBlock("button", {
                                key: tab.value,
                                onClick: ($event) => (activeTab.value = tab.value),
                                class: _normalizeClass(["h-8 px-3.5 text-xs font-medium rounded-md transition-colors",
                                    activeTab.value === tab.value
                                        ? 'bg-eorange-400 text-white'
                                        : 'bg-[#F5F6FA] text-gray-500'
                                ])
                            }, _toDisplayString(tab.label), 11, _hoisted_6));
                        }), 128))
                    ]),
                    _createElementVNode("div", {
                        ref_key: "filterContainerRef",
                        ref: filterContainerRef,
                        class: "relative"
                    }, [
                        _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (filtersOpen.value = !filtersOpen.value)),
                            class: "flex items-center gap-1.5 h-8 px-3 text-xs font-medium text-gray-600 rounded-md border",
                            style: { "background-color": "#f5f6fa", "border-color": "#e5e7eb" }
                        }, [
                            _createVNode(_unref(IconFilter), { class: "w-3.5 h-3.5" }),
                            _createTextVNode(" " + _toDisplayString(_unref(t)("conversation.sidebar.more_filters")) + " ", 1),
                            _createVNode(_unref(IconChevronDown), {
                                class: _normalizeClass(["w-3 h-3 transition-transform", filtersOpen.value ? 'rotate-180' : ''])
                            }, null, 8, ["class"])
                        ]),
                        (filtersOpen.value)
                            ? (_openBlock(), _createBlock(ConversationFilters, {
                                key: 0,
                                "model-value": activeFilters.value,
                                services: __props.services ?? [],
                                itineraries: __props.itineraries ?? [],
                                onApply: handleApplyFilters,
                                onClose: _cache[1] || (_cache[1] = ($event) => (filtersOpen.value = false))
                            }, null, 8, ["model-value", "services", "itineraries"]))
                            : _createCommentVNode("", true)
                    ], 512),
                    _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('new-conversation'))),
                        class: "flex items-center justify-center w-full gap-2 text-sm font-medium text-white transition-colors rounded-lg h-9 bg-eorange-400 hover:bg-eorange-500"
                    }, [
                        _createVNode(_unref(IconPlus), { class: "w-4 h-4" }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)("conversation.sidebar.new_conversation")), 1)
                    ])
                ]),
                _createVNode(ConversationList, {
                    conversations: filteredConversations.value,
                    "active-conversation-id": __props.activeConversationId,
                    "is-loading": __props.isLoading,
                    "current-user-id": _unref(currentUserId),
                    class: "flex-1 overflow-hidden",
                    onSelect: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('select', $event)))
                }, null, 8, ["conversations", "active-conversation-id", "is-loading", "current-user-id"])
            ]));
        };
    }
});
